import { createAsyncThunk } from '@reduxjs/toolkit';
import { UserForeignKey } from 'common/types/Entities';

import { APIBaseResponse } from '..';
import { handleListFetch } from '../apiHelpers';

import {
    APIUserProfileForeignSystemDelete,
    APIUserProfileForeignSystemsGet,
    APIUserProfileForeignSystemsPost,
    APIUserProfileForeignSystemsPostParams,
    APIUserProfileForeignSystemsPut,
    APIUserProfileForeignSystemsPutParams } from './UserProfileForeignSystems.api';

export const fetchUserProfileForeignSystems = createAsyncThunk('userForeignSystems/fetchUserProfileForeignSystems', async (item: {userId: string}) => {
    const response = await APIUserProfileForeignSystemsGet(item);
    return response.data;
});

export type PostUserForeignSystemThunkResponse = {
    item: APIUserProfileForeignSystemsPostParams,
    response: APIBaseResponse,
    rows: UserForeignKey[]
}

export const postUserProfileForeignSystem = createAsyncThunk(
    'userForeignSystems/postUserProfileForeignSystem',
    async (item: APIUserProfileForeignSystemsPostParams) => {
        const response = await APIUserProfileForeignSystemsPost(item);
        const rows = await handleListFetch(APIUserProfileForeignSystemsGet({ userId: item.userId }));
        return {
            item,
            response,
            rows,
        };
    });

export type PutUserForeignSystemThunkResponse = {
    item: APIUserProfileForeignSystemsPutParams,
    response: APIBaseResponse,
    rows: UserForeignKey[]
}

export const putUserProfileForeignSystem = createAsyncThunk(
    'userForeignSystems/putUserProfileForeignSystem',
    async (item: APIUserProfileForeignSystemsPutParams) => {
        const response = await APIUserProfileForeignSystemsPut(item);
        const rows = await handleListFetch(APIUserProfileForeignSystemsGet({ userId: item.userId }));
        return {
            item,
            response,
            rows,
        };
    });

export const deleteUserProfileForeignSystems = createAsyncThunk('userForeignSystems/deleteUserProfileForeignSystems', async (item: {
    userId: string,
    foreignSystemId: string,
    })=> {
    const response = await APIUserProfileForeignSystemDelete(item);
    const rows = await handleListFetch(APIUserProfileForeignSystemsGet({ userId: item.userId }));
    return {
        response,
        rows
    };
});
